// Theme: refined-grit
// Auto-generated by scripts/materialize-theme-presets.ts
// Source of truth for theme configuration

import type { ThemePreset } from '@/lib/themes/types'

export const THEME_PRESET: ThemePreset = {
  id: 'refined-grit',
  name: 'REFINED GRIT',
  tagline: 'REFINED GRIT',
  description: 'Textura urbana sofisticada entre concreto e couro, sem efeitos extras.',
  category: 'system-core',
  tier: 'common',
  basePrice: 1575,
  swatches: ['#1D1D1D', '#2A2A2A', '#B89B7A', '#EFE7DA'],
  baseStyle: {
    cardClasses: '',
    shapeVars: {
      '--border-w': '1px',
      '--radius': '8px',
      '--shadow-card': '0 8px 20px rgba(0, 0, 0, 0.20)',
      '--shadow-card-active': '0 10px 24px color-mix(in srgb, var(--primary) 35%, transparent)'
    },
    shellClasses: 'font-mono theme-refined-grit'
  },
  colorVars: {
    '--accent': '#B89B7A',
    '--accent-foreground': '#1D1D1D',
    '--background': '#1D1D1D',
    '--border': '#7A6A55',
    '--card': '#2A2A2A',
    '--card-border-active': 'rgba(184, 155, 122, 0.35)',
    '--card-completed': '#242424',
    '--card-foreground': '#EFE7DA',
    '--card-glow': 'rgba(184, 155, 122, 0.08)',
    '--coin': 'var(--rarity-legendary)',
    '--destructive': '#ef4444',
    '--destructive-foreground': '#0a0a0a',
    '--foreground': '#EFE7DA',
    '--hold-fill': '#B89B7A',
    '--input': '#7A6A55',
    '--modal-bg': '#1D1D1D',
    '--modal-border': '#7A6A55',
    '--modal-overlay-bg': 'rgba(0, 0, 0, 0.75)',
    '--modal-shadow': '0 8px 20px rgba(0, 0, 0, 0.20)',
    '--muted': '#7A6A55',
    '--muted-foreground': '#EFE7DA',
    '--nav-active': '#B89B7A',
    '--nav-bg': '#2A2A2A',
    '--popover': '#2A2A2A',
    '--popover-foreground': '#EFE7DA',
    '--primary': '#B89B7A',
    '--primary-foreground': '#1D1D1D',
    '--ring': '#B89B7A',
    '--secondary': '#7A6A55',
    '--secondary-foreground': '#EFE7DA',
    '--streak': '#B89B7A',
    '--success': '#22c55e',
    '--success-foreground': '#1D1D1D',
    '--xp': '#B89B7A',
    '--xp-bg': '#2A2A2A'
  },
  resolvedVars: {
    '--accent': '#B89B7A',
    '--accent-foreground': '#1D1D1D',
    '--accent-foreground-hsl': '0 0% 11%',
    '--accent-foreground-oklch': 'from #1D1D1D l c h',
    '--accent-hsl': '32 30% 60%',
    '--accent-oklch': 'from #B89B7A l c h',
    '--background': '#1D1D1D',
    '--background-hsl': '0 0% 11%',
    '--background-oklch': 'from #1D1D1D l c h',
    '--border': '#7A6A55',
    '--border-hsl': '34 18% 41%',
    '--border-oklch': 'from #7A6A55 l c h',
    '--border-w': '1px',
    '--card': '#2A2A2A',
    '--card-border-active': 'rgba(184, 155, 122, 0.35)',
    '--card-completed': '#242424',
    '--card-completed-hsl': '0 0% 14%',
    '--card-completed-oklch': 'from #242424 l c h',
    '--card-foreground': '#EFE7DA',
    '--card-foreground-hsl': '37 40% 90%',
    '--card-foreground-oklch': 'from #EFE7DA l c h',
    '--card-glow': 'rgba(184, 155, 122, 0.08)',
    '--card-hsl': '0 0% 16%',
    '--card-oklch': 'from #2A2A2A l c h',
    '--coin': 'var(--rarity-legendary)',
    '--destructive': '#ef4444',
    '--destructive-foreground': '#0a0a0a',
    '--destructive-foreground-hsl': '0 0% 4%',
    '--destructive-foreground-oklch': 'from #0a0a0a l c h',
    '--destructive-hsl': '0 84% 60%',
    '--destructive-oklch': 'from #ef4444 l c h',
    '--foreground': '#EFE7DA',
    '--foreground-hsl': '37 40% 90%',
    '--foreground-oklch': 'from #EFE7DA l c h',
    '--hold-fill': '#B89B7A',
    '--hold-fill-hsl': '32 30% 60%',
    '--hold-fill-oklch': 'from #B89B7A l c h',
    '--input': '#7A6A55',
    '--input-hsl': '34 18% 41%',
    '--input-oklch': 'from #7A6A55 l c h',
    '--modal-bg': '#1D1D1D',
    '--modal-bg-hsl': '0 0% 11%',
    '--modal-bg-oklch': 'from #1D1D1D l c h',
    '--modal-border': '#7A6A55',
    '--modal-border-hsl': '34 18% 41%',
    '--modal-border-oklch': 'from #7A6A55 l c h',
    '--modal-overlay-bg': 'rgba(0, 0, 0, 0.75)',
    '--modal-shadow': '0 8px 20px rgba(0, 0, 0, 0.20)',
    '--muted': '#7A6A55',
    '--muted-foreground': '#EFE7DA',
    '--muted-foreground-hsl': '37 40% 90%',
    '--muted-foreground-oklch': 'from #EFE7DA l c h',
    '--muted-hsl': '34 18% 41%',
    '--muted-oklch': 'from #7A6A55 l c h',
    '--nav-active': '#B89B7A',
    '--nav-active-hsl': '32 30% 60%',
    '--nav-active-oklch': 'from #B89B7A l c h',
    '--nav-bg': '#2A2A2A',
    '--nav-bg-hsl': '0 0% 16%',
    '--nav-bg-oklch': 'from #2A2A2A l c h',
    '--popover': '#2A2A2A',
    '--popover-foreground': '#EFE7DA',
    '--popover-foreground-hsl': '37 40% 90%',
    '--popover-foreground-oklch': 'from #EFE7DA l c h',
    '--popover-hsl': '0 0% 16%',
    '--popover-oklch': 'from #2A2A2A l c h',
    '--primary': '#B89B7A',
    '--primary-foreground': '#1D1D1D',
    '--primary-foreground-hsl': '0 0% 11%',
    '--primary-foreground-oklch': 'from #1D1D1D l c h',
    '--primary-hsl': '32 30% 60%',
    '--primary-oklch': 'from #B89B7A l c h',
    '--radius': '8px',
    '--ring': '#B89B7A',
    '--ring-hsl': '32 30% 60%',
    '--ring-oklch': 'from #B89B7A l c h',
    '--secondary': '#7A6A55',
    '--secondary-foreground': '#EFE7DA',
    '--secondary-foreground-hsl': '37 40% 90%',
    '--secondary-foreground-oklch': 'from #EFE7DA l c h',
    '--secondary-hsl': '34 18% 41%',
    '--secondary-oklch': 'from #7A6A55 l c h',
    '--shadow-card': '0 8px 20px rgba(0, 0, 0, 0.20)',
    '--shadow-card-active': '0 10px 24px color-mix(in srgb, var(--primary) 35%, transparent)',
    '--streak': '#B89B7A',
    '--streak-hsl': '32 30% 60%',
    '--streak-oklch': 'from #B89B7A l c h',
    '--success': '#22c55e',
    '--success-foreground': '#1D1D1D',
    '--success-foreground-hsl': '0 0% 11%',
    '--success-foreground-oklch': 'from #1D1D1D l c h',
    '--success-hsl': '142 71% 45%',
    '--success-oklch': 'from #22c55e l c h',
    '--tint-primary-subtle': 'hsla(32 30% 60% / 0.15)',
    '--xp': '#B89B7A',
    '--xp-bg': '#2A2A2A',
    '--xp-bg-hsl': '0 0% 16%',
    '--xp-bg-oklch': 'from #2A2A2A l c h',
    '--xp-hsl': '32 30% 60%',
    '--xp-oklch': 'from #B89B7A l c h'
  }
}
